import { all, takeLatest, fork, put } from 'redux-saga/effects';
import AuthApi from 'libs/api/auth';
import AuthService from 'services/Auth';
import routeCodes from 'common/constants/route-codes';

import * as types from './types';
import UserApi from '../../libs/api/user';

const api = new AuthApi();
const usersApi = new UserApi();

function* userLogin({ payload }) {
  try {
    const { history, data: formData } = payload;
    const { data } = yield api.signIn({ data: formData });
    AuthService.setToken(data.token);
    yield put({
      type: types.USER_LOGIN_SUCCESS,
      payload: data,
    });
    if (data.role !== 'root') {
      yield put({
        type: types.USER_GET_AUTH_USER,
      });
      return history.push(`${routeCodes.chooseRestaurant}${window.location.search}`);
    }
    history.push(routeCodes.home);
  } catch (e) {
    yield put({
      type: types.USER_LOGIN_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* userResetPassword({ payload }) {
  try {
    const { history, data: formData } = payload;
    const { data } = yield api.sendPassword({ data: formData });
    yield put({
      type: types.USER_RESET_PASSWORD_SUCCESS,
      payload: data,
    });
    history?.push(routeCodes.signIn);
  } catch (e) {
    yield put({
      type: types.USER_RESET_PASSWORD_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* sendResetPassword({ payload }) {
  try {
    const { data } = yield api.resetPassword({ data: payload });
    yield put({
      type: types.USER_SEND_RESET_PASSWORD_SUCCESS,
      payload: data,
    });
  } catch (e) {
    yield put({
      type: types.USER_SEND_RESET_PASSWORD_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* getAuthUser({ payload }) {
  try {
    const { data } = yield usersApi.get('me');
    yield put({
      type: types.USER_GET_AUTH_USER_SUCCESS,
      payload: data,
    });
  } catch (e) {
    yield put({
      type: types.USER_GET_AUTH_USER_FAILURE,
    });
    if (payload.history && payload.pathname) {
      const publicRoutes = [
        routeCodes.signIn,
        routeCodes.forgetPassword,
        routeCodes.newPassword,
        routeCodes.register
      ];
      
      if (!publicRoutes.includes(payload.pathname)) {
        payload.history.push(`${routeCodes.signIn}${window.location.search}`);
      }
    }
  }
}

function* userSignup({ payload, meta }) {
  try {
    const { data: formData } = payload;
    const { data } = yield api.signup({ data: formData });
    
    console.log('Signup saga response:', data);
    
    // Зберігаємо токен в AuthService
    if (data.token) {
      AuthService.setToken(data.token);
    }
    
    yield put({
      type: types.USER_SIGNUP_SUCCESS,
      payload: data,
    });

    // Викликаємо resolve з успішним результатом
    if (meta?.resolve) {
      meta.resolve({ data });
    }
  } catch (e) {
    console.error('Signup saga error:', e?.response?.data);
    
    // Передаємо всі дані про помилку, включаючи валідаційні помилки
    const errorData = e?.response?.data || { message: 'Errore durante la registrazione' };
    
    yield put({
      type: types.USER_SIGNUP_FAILURE,
      payload: errorData,
    });

    // Викликаємо reject з помилкою
    if (meta?.reject) {
      meta.reject(e);
    }
  }
}

function* confirmPhone({ payload, meta }) {
  try {
    const { data: formData } = payload;
    const { data } = yield api.confirmPhone({ data: formData });
    
    yield put({
      type: types.USER_CONFIRM_PHONE_SUCCESS,
      payload: data,
    });

    if (meta?.resolve) {
      meta.resolve({ data });
    }
  } catch (e) {
    yield put({
      type: types.USER_CONFIRM_PHONE_FAILURE,
      payload: e?.response?.data,
    });

    if (meta?.reject) {
      meta.reject(e);
    }
  }
}
function* resendCodePhone({ payload, meta }) {
  try {
    const { data: formData } = payload;
    const { data } = yield api.resendCodePhone({ data: formData });

    yield put({
      type: types.USER_CONFIRM_PHONE_SUCCESS,
      payload: data,
    });

    if (meta?.resolve) {
      meta.resolve({ data });
    }
  } catch (e) {
    yield put({
      type: types.USER_CONFIRM_PHONE_FAILURE,
      payload: e?.response?.data,
    });

    if (meta?.reject) {
      meta.reject(e);
    }
  }
}

function* resendCodeEmail({ payload, meta }) {
  try {
    const { data: formData } = payload;
    const { data } = yield api.resendCodeEmail({ data: formData });

    yield put({
      type: types.USER_RESEND_EMAIL_CODE_SUCCESS,
      payload: data,
    });
    
  } catch (e) {
    yield put({
      type: types.USER_RESEND_EMAIL_CODE_FAILURE,
      payload: e?.response?.data,
    });

    if (meta?.reject) {
      meta.reject(e);
    } 
  }
}

function* changeEmail({ payload }) {
  try {
    const { data: formData } = payload;
    const token = AuthService.getToken();
    
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    const { data } = yield api.changeEmail({ data:{ email: formData.email } });
    
    yield put({
      type: types.USER_CHANGE_EMAIL_SUCCESS,
      payload: data,
    });
  } catch (e) {
    console.error('Change email error:', e?.response?.data || e.message);
    yield put({
      type: types.USER_CHANGE_EMAIL_FAILURE,
      payload: e?.response?.data || { message: e.message },
    });
  }
}

function* changePhone({ payload, meta }) {
  try {
    const { data: formData } = payload;
    const { data } = yield api.changePhone({ data: { phone: formData.phone } });
    
    yield put({
      type: types.USER_CHANGE_PHONE_SUCCESS,
      payload: data,
    });

    if (meta?.resolve) {
      meta.resolve({ data });
    }
  } catch (e) {
    yield put({
      type: types.USER_CHANGE_PHONE_FAILURE,
      payload: e?.response?.data,
    });

    if (meta?.reject) {
      meta.reject(e);
    }
  }
}

function* confirmEmail({ payload, meta }) {
  try {
    const { data: formData } = payload;
    const { data } = yield api.confirmEmail({ data: formData });
    
    yield put({
      type: types.USER_CONFIRM_EMAIL_SUCCESS,
      payload: data,
    });

    if (meta?.resolve) {
      meta.resolve({ data });
    }
  } catch (e) {
    console.error('Confirm email error:', e?.response?.data);
    
    const errorData = e?.response?.data || { message: 'Errore durante la conferma email' };
    
    yield put({
      type: types.USER_CONFIRM_EMAIL_FAILURE,
      payload: errorData,
    });

    if (meta?.reject) {
      meta.reject(e);
    }
  }
}

function* finishPhone({ payload, meta }) {
  try {
    const { data: formData } = payload;
    console.log('Finish phone payload:', formData);
    
    const { data } = yield api.finishPhone({ data: formData });
    console.log('Finish phone response:', data);
    
    yield put({
      type: types.USER_FINISH_PHONE_SUCCESS,
      payload: data,
    });

    if (meta?.resolve) {
      meta.resolve({ data });
    }
  } catch (e) {
    console.error('Finish phone error:', e?.response?.data);
    
    const errorData = e?.response?.data || { message: 'Errore durante la conferma del telefono' };
    
    yield put({
      type: types.USER_FINISH_PHONE_FAILURE,
      payload: errorData,
    });

    if (meta?.reject) {
      meta.reject(e);
    }
  }
}

function* watchUserLoginRequest() {
  yield takeLatest(types.USER_LOGIN_REQUEST, userLogin);
}
function* watchUserResetPasswordRequest() {
  yield takeLatest(types.USER_RESET_PASSWORD_REQUEST, userResetPassword);
}

function* watchAuthUser() {
  yield takeLatest(types.USER_GET_AUTH_USER, getAuthUser);
}

function* watchSendResetPasswordRequest() {
  yield takeLatest(types.USER_SEND_RESET_PASSWORD_REQUEST, sendResetPassword);
}

function* watchUserSignupRequest() {
  yield takeLatest(types.USER_SIGNUP_REQUEST, userSignup);
}

function* watchConfirmPhone() {
  yield takeLatest(types.USER_CONFIRM_PHONE_REQUEST, confirmPhone);
}

function* watchResendCodePhone() {
  yield takeLatest(types.USER_RESEND_PHONE_CODE_REQUEST, resendCodePhone);
}

function* watchChangeEmail() {
  yield takeLatest(types.USER_CHANGE_EMAIL_REQUEST, changeEmail);
}

function* watchChangePhone() {
  yield takeLatest(types.USER_CHANGE_PHONE_REQUEST, changePhone);
}

function* watchConfirmEmail() {
  yield takeLatest(types.USER_CONFIRM_EMAIL_REQUEST, confirmEmail);
}

function* watchFinishPhone() {
  yield takeLatest(types.USER_FINISH_PHONE_REQUEST, finishPhone);
}

function* watchResendCodeEmail() {
  yield takeLatest(types.USER_RESEND_EMAIL_CODE_REQUEST, resendCodeEmail);
}

export default function* userSagas() {
  yield all([
    fork(watchUserLoginRequest),
    fork(watchUserResetPasswordRequest),
    fork(watchAuthUser),
    fork(watchSendResetPasswordRequest),
    fork(watchUserSignupRequest),
    fork(watchConfirmPhone),
    fork(watchResendCodePhone),
    fork(watchChangeEmail),
    fork(watchChangePhone),
    fork(watchConfirmEmail),
    fork(watchFinishPhone),
    fork(watchResendCodeEmail),
  ]);
}
